import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { ErrorComponent, JwlTable, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

import FontCreateDialog from '../FontCreateDialog';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';

interface IProps {
  party: GQLParty;
}

const FontList: React.FC<IProps> = ({ party }) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [showFontCreateDialog, setShowFontCreateDialog] = useState(false);
  const [filteredFonts, setFilteredFonts] = useState('');
  const history = useHistory();

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.font.getFontsByPlatform({});

  const reloadFonts = () => {
    refetch().then();
  };

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;
  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        message={error.message}
        callback={reloadFonts}
      />
    );

  const handleFilterChange = (event: any) => setFilteredFonts(event.target.value);

  const getFontRows = () => {
    return GQLOperationBuilder.font
      .fontAssetArrayFromResponse(data)
      .filter(font => {
        return font.font.name.toLowerCase().includes(filteredFonts.toLowerCase().trim());
      })
      .sort((f1, f2) => f1.font.name.localeCompare(f2.font.name))
      .map(font => {
        return {
          id: font.id,
          cells: [
            font.font.name,
            new Date(Date.parse(font.createdAt)).toLocaleString(),
            new Date(Date.parse(font.updatedAt)).toLocaleString()
          ]
        };
      });
  };

  const navigateToFontDetails = (fontId: string) => {
    history.push(PlatformNavigation.fontDetails.pathFromParams({ fontId: fontId }));
  };

  return (
    <Fragment>
      <JwlTable
        title="Platform fonts list"
        description={`The list of all fonts defined in the system.`}
        columns={['Name', 'Created At', 'Updated At']}
        rows={getFontRows()}
        onFilterChange={handleFilterChange}
        onTableRowClick={navigateToFontDetails}
        children={
          <Button
            variant="contained"
            color={'primary'}
            onClick={() => setShowFontCreateDialog(true)}
            style={{ marginLeft: '4px' }}
          >
            <AddIcon />
            <span style={{ marginLeft: '4px' }}>Font</span>
          </Button>
        }
      />
      {showFontCreateDialog && (
        <FontCreateDialog
          party={party}
          onClose={val => {
            setShowFontCreateDialog(val);
            refetch();
          }}
        ></FontCreateDialog>
      )}
    </Fragment>
  );
};

export default FontList;
